import { marker } from '@jsverse/transloco-keys-manager/marker';
import { FormValidationError } from './form-validation-error.enum';

export const formValidationErrors: { [key in FormValidationError]: string } = {
  [FormValidationError.OVERRIDEN_GAM_PATIENT]: marker(
    'Impossible de modifier un patient enregistré dans votre établissement.',
  ),
  [FormValidationError.OVERRIDEN_LOCAL_PATIENT]: marker(
    "Impossible de modifier un patient dont l'identifiant correspond à celui d'un autre patient.",
  ),
  [FormValidationError.INVALID]: marker('Un ou plusieurs champs sont invalides.'),
};
